// extracted by mini-css-extract-plugin
export default {"TextFieldLabel":"styles_TextFieldLabel__4dArR","contactItem":"styles_contactItem__CDgwB","contactIconItem":"styles_contactIconItem__425cc","icon":"styles_icon__zwbcN"};